export const GET_LIST_PARENT_REPORTS = 'GET_LIST_PARENT_REPORTS'
export const GET_LIST_PARENT_REPORTS_ERROR = 'GET_LIST_PARENT_REPORTS_ERROR'

export const GET_LIST_REPORTS = 'GET_LIST_REPORTS'
export const GET_LIST_REPORTS_ERROR = 'GET_LIST_REPORTS_ERROR'

export const SET_PARENT_CONDITION_FILTER = "SET_PARENT_CONDITION_FILTER"
export const SET_CONDITION_FILTER = "SET_CONDITION_FILTER"

export const CLEAR_LIST_REPORT = "CLEAR_LIST_REPORT"